var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[(_vm.menu && _vm.menu.length)?_c('ul',_vm._l((_vm.menu),function(item,id){return _c('li',{key:id},[_c('a',{attrs:{"href":item.slug}},[_vm._v(_vm._s(item.label))])])}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }